import React, { useEffect, useState } from 'react';

import { CircularProgress } from '@mui/material';

import { cn } from 'components/lib/utils';

import { StorePreview } from '../../Preview/Preview';

import { usePreview } from './usePreview.hook';

export const TemplateStudioPreview: React.FC<{
  isLoadingForm: boolean;
}> = ({ isLoadingForm }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { previewProps } = usePreview();

  useEffect(() => {
    setIsLoading(!previewProps || !previewProps.boot || !previewProps.offers);
  }, [previewProps]);

  return (
    <div
      className={cn(
        'flex flex-1 min-w-0 h-auto justify-center items-center bg-neutral-100 rounded-lg mb-6 px-6 pt-6',
        isLoadingForm && 'opacity-0'
      )}
    >
      {isLoading ? (
        <CircularProgress
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            height: '60px',
            width: '60px'
          }}
        />
      ) : (
        <StorePreview previewProps={previewProps} />
      )}
    </div>
  );
};
